// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"a1ec4fd2","356":"c4f9f761","385":"1e133d10","510":"400eb058","984":"64df7671"}[chunkId] + ".chunk.js";
};